import styled from 'styled-components';

export const Label = styled.label`
  &::before {
    content: '\\a0';
    display: inline-block;
    border: 1px solid rgba(26, 62, 81, 1);
    text-align: center;
    width: 20px;
    height: 20px;
    font-weight: bold;
  }
`;

export const Checkbox = styled.input.attrs(props => ({
  type: 'checkbox'
}))`
  /*
    display: none;这样会让tab键无法选取自定义的checkbox，所以使用下面的方法
    clip 属性剪裁绝对定位元素。
    */
  position: absolute;
  clip: rect(0, 0, 0, 0);

  &:checked + ${Label}::before {
    content: '\\2713';
    color: #1cf2f2;
  }
`;
